import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { getSessionByKey, GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import { TreatmentAssignColumns } from '../gridcolumns';

const TreatmentAssignments = ({ getToken, protocolNumber }) => (
  <GridTable
    tag={`${TE.ID}treatmentassignments${TE.TABLE}`}
    title="Treatment Assignment(s)"
    exportTitle={`Treatment Assignment(s)-${useGetPathProtocol()}-Study Agents`}
    remoteUrl={`protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/number/${protocolNumber}/treatmentassignments`}
    columns={TreatmentAssignColumns}
    user={GetUserFullName()}
    enableToolbar
    getToken={getToken}
    filterable
    sortable
    recordPerPage={10}
    toPdf={false}
  />
);

export default TreatmentAssignments;
